<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { annotationMixin } from '@/mixins/annotationMixin'

import PlotlyLineChart from '@/components/plotly-chart/PlotlyLineChart.vue'

const store = useStore()
const { annotations } = annotationMixin(store)
const storeNameSpace = 'loads'

const currentTopoProfile = computed(() => store.state.topoProfile.currentItem)
const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

const topoPlotData = computed(() => store.getters['topoProfilePoint/getPlotData'])
const soilLayerPlotData = computed(() => store.getters['soilLayer/getPlotData'])
const treeLoadPlotData = computed(() => store.getters['treeLoads/getPlotData'])
const uniformLoadsPlotData = computed(() => store.getters['uniformLoads/getPlotData'])

const getChartYAxisRange = computed(() => (id) => {
  return store.getters['topoProfilePoint/getChartYAxisRange'](id)
})
const refPlot = computed(() => `${storeNameSpace}-${currentStabSchematisationStage.value?.id}`)

const combinedPlotData = computed(() => {
  return [
    ...soilLayerPlotData.value(),
    ...topoPlotData.value(),
    ...uniformLoadsPlotData.value(),
    ...treeLoadPlotData.value()
  ]
})

const setActiveItem = (event) => {
  if (event.points[0].data.storeName) {
    store.dispatch(`${event.points[0].data.storeName}/setCurrentItem`, event.points[0].data.item)
  }
}
</script>
<template>
  <PlotlyLineChart
    v-if="currentTopoProfile"
    class="fill-height"
    :responsive="false"
    :data="combinedPlotData"
    :annotations="annotations"
    :showAnimate="false"
    :refPlot="refPlot"
    :ref="refPlot"
    :clickEvent="true"
    :yAxisRange="getChartYAxisRange(currentTopoProfile?.id)"
    @action="setActiveItem"
  ></PlotlyLineChart>
</template>
